/* bonic · Birthday Beauty Box funnel. Dynamic shade selection -> matches the real variant -> straight to checkout. Fail-safe. */
(function(){
  try{
    var root=document.getElementById('bbox'); if(!root) return;
    if(window.__bboxInit) return; window.__bboxInit=1;

    var chosen={};            // position -> value
    var positions=[];         // ordered option positions present on the page

    root.querySelectorAll('.chip[data-pos]').forEach(function(ch){
      var p=ch.getAttribute('data-pos');
      if(positions.indexOf(p)===-1) positions.push(p);
      ch.addEventListener('click',function(){
        root.querySelectorAll('.chip[data-pos="'+p+'"]').forEach(function(o){o.classList.remove('sel');});
        ch.classList.add('sel');
        chosen[p]=ch.getAttribute('data-value');
        var grp=ch.closest('.grp'); if(grp) grp.classList.add('done');
        var n=document.getElementById('bbox-note'); if(n) n.textContent='';
      });
    });
    positions.sort(function(a,b){return (a*1)-(b*1);});

    function allChosen(){ return positions.length>0 && positions.every(function(p){return chosen[p];}); }
    function variantId(){
      var map=window.__bboxVariants||{};
      var key=positions.map(function(p){return chosen[p];}).join('|');
      return map[key] || parseInt(root.getAttribute('data-vid'),10);
    }

    function toCheckout(btn){
      if(!allChosen()){
        var n=document.getElementById('bbox-note'); if(n) n.textContent='בחרי את כל הגוונים למעלה כדי להמשיך לתשלום';
        var sel=document.getElementById('bbox-choose'); if(sel) sel.scrollIntoView({behavior:'smooth',block:'center'});
        return;
      }
      var vid=variantId(); if(!vid) return;
      if(btn){ btn.style.opacity=.7; btn.disabled=true; }
      try{ window.__bnCartGiftOp=true; }catch(e){}
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:vid,quantity:1}]})})
       .then(function(r){return r.json();}).then(function(){ window.location.href='/checkout'; })
       .catch(function(){ if(btn){btn.style.opacity=1;btn.disabled=false;} try{window.__bnCartGiftOp=false;}catch(e){} });
    }
    root.querySelectorAll('[data-bbox-buy]').forEach(function(b){ b.addEventListener('click',function(){toCheckout(b);}); });
    var sb=document.getElementById('bbox-sticky'); if(sb){ var sbtn=sb.querySelector('.b'); if(sbtn) sbtn.addEventListener('click',function(){toCheckout(sbtn);}); }

    root.querySelectorAll('[data-bbox-scroll]').forEach(function(a){
      a.addEventListener('click',function(e){e.preventDefault();var s=document.getElementById('bbox-choose');if(s)s.scrollIntoView({behavior:'smooth',block:'start'});});
    });

    function upd(){ try{ var h=root.querySelector('.hero'); if(!h||!sb) return; sb.classList.toggle('show',h.getBoundingClientRect().bottom<0); }catch(e){} }
    upd(); window.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd);

    try{
      var target=new Date('2026-10-12T00:00:00+03:00').getTime();
      var e={d:document.getElementById('bb-d'),h:document.getElementById('bb-h'),m:document.getElementById('bb-m'),s:document.getElementById('bb-s')};
      function pad(n){ return (n<10?'0':'')+n; }
      function tick(){ var diff=target-Date.now(); if(diff<0)diff=0;
        var d=Math.floor(diff/864e5),h=Math.floor(diff%864e5/36e5),m=Math.floor(diff%36e5/6e4),s=Math.floor(diff%6e4/1e3);
        if(e.d)e.d.textContent=d; if(e.h)e.h.textContent=pad(h); if(e.m)e.m.textContent=pad(m); if(e.s)e.s.textContent=pad(s); }
      if(e.d||e.h){ tick(); setInterval(tick,1000); }
    }catch(e){}
  }catch(e){}
})();
